import { API_BASE_URL } from "./constants/Constants";

const CONFIG_CACHE_KEY = 'runtimeConfig';

export const loadRuntimeConfig = async () => {
  // If env-config.js already populated window._env_ (via <script> in index.html),
  // update the cache with these values and use them directly.
  if (window._env_ && Object.keys(window._env_).length > 0) {
    sessionStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify(window._env_));
    return;
  }

  // Fallback: try sessionStorage cache
  const cachedConfig = sessionStorage.getItem(CONFIG_CACHE_KEY);
  if (cachedConfig) {
    try {
      window._env_ = JSON.parse(cachedConfig);
      return;
    } catch (e) {
      console.warn("Could not parse cached config, fetching from API.");
      sessionStorage.removeItem(CONFIG_CACHE_KEY);
    }
  }

  // Fallback: fetch from API
  const baseUrl = API_BASE_URL;
  const configUrl = baseUrl + "api/config";

  try {
    const response = await fetch(configUrl);
    if (!response.ok) {
      throw new Error(`Config server returned ${response.status}`);
    }
    const runtimeConfig = await response.json();
    window._env_ = runtimeConfig;
    sessionStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify(window._env_));
  } catch (error) {
    console.error(
      "CRITICAL: Could not load runtime config. App will not function.",
      error
    );
    window._env_ = {};
  }
};